import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Entry } from 'contentful';

import { ContentService } from '../shared/services/content.service';
import { EntryData } from '../shared/interfaces/entryData';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})

export class BlogComponent implements OnInit, OnDestroy {
	entries: Entry<any>[] = [];
	entriesAll: Entry<any>[] = [];
	entriesSub: Subscription;

	hero = {
    title: 'From the Journal',
    subtitle: 'Insights on tech, marketing, and the elusive work-life balance' /* 'Lessons learned from living & creating' */,
    image: ''
  };

	bcHeading: string = 'Search or filter here'
	search: string = '';
	filter: object[] = [];

	constructor(
		private router: Router,
		private contentService: ContentService
	) { }

	get filtered() {
		const s = this.search.toLowerCase(), 
					f = this.filter,
					
					query = this.entries.filter(
						e => !s || 
						e.fields.title.toLowerCase().includes(s) || 
						e.fields.description.toLowerCase().includes(s) || 
						e.metadata.tags.join(' ').includes(s) || 
						e.fields.categories.join(' ').toLowerCase().includes(s)
					);

		if (
			f.length > 0 && 
			!f.every(e => !e['values'].length)
		)
			return query.filter((e) => {
				return f.map((e2) => {
					if (!e2['values'].length) {
						return false;
					} else if ((
						e2['type'] === 'categories' &&
						e.fields?.categories?.some(e3 => e2['values'].includes(e3))
					) || (
						e2['type'] === 'tags' && 
						e.metadata?.tags?.map(
							e3 => this.contentService.tagIDtoName(e3.sys.id)
						).some(e4 => e2['values'].includes(e4))
					)) {
						return e;
					} else {
						return false;
					}
				}).includes(e)
			})
			
		return query;
	}

	getEntries(): Subscription {
		return this.contentService.getEntries(null, '-fields.date', { 'fields.entryType': 'Blog' }, 'vipEntry').subscribe(data =>
			this.entries = this.entriesAll = data
		);
	}

	openEntry(e: EntryData) {
		this.router.navigate(['/blog/entries', e.entry.fields?.slug || e.entry.sys.id], { state: { data: e.entries } });
	}

	onSearchChange($event: any) {
		this.search = $event.target.parentElement
	}

	// Lifecycle Hooks

  ngOnInit(): void {
		this.getEntries();
	}

	ngOnDestroy(): void {
		this.getEntries().unsubscribe();
	}	
}
